import {
    WALLET_LOGIN_SUCCESS,
    WALLET_LOGIN_ERROR,
    WALLET_CREATION_ERROR,
    WALLET_CREATION_SUCCESS,
    WALLET_CREATION_SUBMIT,
    WALLET_SMS_ERROR,
    WALLET_SMS_SUBMIT,
    WALLET_SMS_SUCCESS,
    WALLET_LOGIN_SUBMIT,
    WALLET_FINISH_ERROR,
    WALLET_FINISH_LOAD,
    WALLET_FINISH_SUCCESS,
    WALLET_LOGIN_EXPIRED,
    WALLET_BTC_ADDRESS_ERROR,
    WALLET_BTC_ADDRESS_SUCCESS,
    WALLET_BTC_ADDRESS_LOAD,
    WALLET_LISTA_ERROR,
    WALLET_LISTA_SUBMIT,
    WALLET_LISTA_SUCCESS
} from '../actionTypes'

import {
    setInfoLocalStorage,
    getInfoLocalStorage
} from '../../utils/api'

import moment from 'moment'

const setStateLocalStorage = getInfoLocalStorage()

const initialState = {
    userExpiration: setStateLocalStorage.userExpiration || null,
    isLoading: false,
    isLoadingSMS: false,
    step: 1,
    message: '',
    success: true,
    successCreation: true,
    favorites: [],
    addressCreation: false,
    balance: setStateLocalStorage.brlBalance || 0,
    creationToken: setStateLocalStorage.creationToken || null,
    loginExpired: false,
    idWallet: setStateLocalStorage.idWallet || null,
    walletLogged: setStateLocalStorage.walletLogged || false
}

export default (state = initialState, action) => {
    switch(action.type) {
        case WALLET_LISTA_SUBMIT:
            return {
                ...state,
                isLoading: true
            }
        case WALLET_LISTA_ERROR:
            return {
                ...state,
                isLoading: false,
                message: action.payload.message,
                success: false
            }
        case WALLET_LISTA_SUCCESS:
            return {
                ...state,
                isLoading: false,
                message: action.payload.message,
                success: true
            }

        case WALLET_BTC_ADDRESS_SUCCESS:
            return {
                ...state,
                success: true,
                step: 3,
                message: 'Wallet criada com sucesso, por favor confirme sua senha.',
                successCreation: false,
                addressCreation: false,
                isLoading: false,
            }

        case WALLET_BTC_ADDRESS_ERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
                message: 'Houve um erro ao gerar seu endereço, mas fique tranquilo, você poderá gerar outro dentro de nossa plataforma.',
                successCreation: false,
                step: 3,
                addressCreation: false,
            }

        case WALLET_BTC_ADDRESS_LOAD:
            return {
                ...state,
                isLoading: true,
                successCreation: true,
                addressCreation: true,
            }

        case WALLET_FINISH_SUCCESS:
            return {
                ...state,
                successCreation: true,
                isLoading: false
            }

        case WALLET_FINISH_ERROR: 
            return {
                ...state,
                successCreation: false,
                isLoading: false,
                message: action.payload.message
            }

        case WALLET_FINISH_LOAD:
            return {
                ...state,
                isLoading: true
            }

        case WALLET_SMS_SUBMIT:
            return {
                ...state,
                isLoadingSMS: true
            }

        case WALLET_SMS_ERROR:
            return {
                ...state,
                step: 2,
                isLoadingSMS: false,
                message: action.payload.message
            }

        case WALLET_SMS_SUCCESS:
            return {
                ...state,
                step: 2,
                isLoadingSMS: false,
                message: action.payload.message
            }

        case WALLET_CREATION_SUCCESS:
            const walletCreation = {
                creationToken: action.payload.token
            }
            setInfoLocalStorage(walletCreation)
            return {
                ...state,
                isLoading: false,
                walletCreation,
                step: 2,
                message: '',
                success: true
            }

        case WALLET_CREATION_ERROR:
            return {
                ...state,
                isLoading: false,
                step: 1,
                message: action.payload.message,
                success: false,
            }

        case WALLET_CREATION_SUBMIT:
            return{
                ...state,
                isLoading: true
            }

        case WALLET_LOGIN_SUBMIT:
            return{
                ...state,
                isLoading: true
            }

        case WALLET_LOGIN_SUCCESS:
            const walletInfo = {
                userExpiration: moment().add(2, 'hours'),
                idWallet: action.payload.idWallet,
                walletLogged: true
            }
            setInfoLocalStorage(walletInfo)
            return {
                ...state,
                isLoading: false,
                loginExpired: false,
                walletLogged: true,
                ...walletInfo
            }

        case WALLET_LOGIN_ERROR:
            return {
                ...state,
                isLoading: false,
                success: false
            }

        case WALLET_LOGIN_EXPIRED:
            const walletInfo2 = {
                walletLogged: false
            }
            setInfoLocalStorage(walletInfo2)
            return {
                ...state,
                loginExpired: true,
                walletLogged: false
            }           

        default:
            return state
    }
}